export default "__VITE_ASSET__DWGBPFHz__"